import axios from "axios";

// axios.defaults.baseURL = 'https://educarteudec.com/api/v1/';
// axios.defaults.baseURL = 'http://localhost:4000/api/v1/'
axios.defaults.baseURL = 'https://serverpractica.herokuapp.com/api/v1/';
axios.defaults.headers.common['token'] = localStorage.getItem('token') || null;
